import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DisplayOnlyInput extends Component {
    static propTypes = {
        input: PropTypes.object,
        Wrapper: PropTypes.string,
        preValue: PropTypes.string,
        postValue: PropTypes.string,
        className: PropTypes.string,
        transformValue: PropTypes.func
    };

    render() {
        const {
            input = {},
            Wrapper = 'span',
            className = '',
            preValue = '',
            postValue = '',
            transformValue
        } = this.props;
        const { value = '' } = input;
        let displayValue = value;
        if (transformValue) {
            displayValue = transformValue(value);
        }
        return (
            <Wrapper className={`form-control-static ${className}`}>
                {preValue}
                {displayValue}
                {postValue}
            </Wrapper>
        );
    }
}

export default DisplayOnlyInput;
